import { useEffect, useState } from 'react';
import '../../Style/form-submit/confirm.css';
import CardExpandConfirmWidget from '../../Widgets/card-expand-confirm/CardExpandConfirmWidget';
import RuleConfirmWidget from '../../Widgets/rule-confirm/RuleConfirmWidget';
import '../../Style/font_responsive.css';
import { formatYYYYMMDDToDDMMYYYY, isNullOrEmpty, removeDotFromStringMoney } from '../../Services/service';
import { t } from 'i18next';
function ConfirmInformationSection({objectDto, setObjectDto, setState, province, ward, contactWard, occupation}){
    
    const [checked, setChecked] = useState(objectDto.confirm !== undefined ? (objectDto.confirm === 1 ? true : false) : false);
    useEffect(()=>{
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
        setState(objectDto.confirm === 1);
    },[])
    useEffect(()=>{
        setState(checked);
        setObjectDto(prev => ({...prev,confirm: checked ? 1 : 0}));
    },[checked])
    return(
        <section className="confirm-information">
            <div className="container-confirm-information">
                <div className="confirm-information-wrapper">
                    <div className="confirm-infor-form">
                        <div className="title-confirm-infor-wrap">
                            <h2 className="title-font-confirm-infor">{t("titleconfirminformation")}</h2>
                        </div>
                        
                        <div className='border-form-group-confirm-information'>
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line two-column">
                                    <label className='lbl-wbox'>{t("fullnamefill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.fullName}</label>
                                </div>
                                
                                <div className="form-group-confirm-information same-line two-column">
                                    <label className='lbl-wbox'>{t("emailfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.email}</label>    
                                </div>
                            </div>
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("birthfill")}</label>
                                    <label className='lbl-wbox-value'>{formatYYYYMMDDToDDMMYYYY(objectDto.dob)}</label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("genderfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.gender === 0 ? t("gendermale") : t("genderfemale")}</label>                            
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("phonenumberfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.phoneNumber}</label>
                                </div>
                            </div>

                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("birthplacefill")}</label>
                                    <label className='lbl-wbox-value'>
                                        { 
                                            !isNullOrEmpty(province) ? province.map((item)=>{
                                                if(item.code === objectDto.birthPlace) return item.name;
                                            }) 
                                            : 
                                            <></>
                                        }
                                    </label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("occupationfill")}</label>
                                    <label className='lbl-wbox-value'>
                                        { 
                                            !isNullOrEmpty(occupation) ? occupation.map((item)=>{
                                                if(item.id === objectDto.occupationId ) return item.descriptionVn;
                                            }) 
                                            : 
                                            <></>
                                        }
                                    </label>
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("maritalfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.married === "0" ? t("singlemarital") : t("marriagemarital")}</label>
                                </div>
                            </div>
                            
                            <div className='form-group-list-confirm-information'>
                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("idfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.idnumber}</label>    
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("dateidfill")}</label>
                                    <label className='lbl-wbox-value'>{formatYYYYMMDDToDDMMYYYY(objectDto.iddate)}</label>  
                                </div>

                                <div className="form-group-confirm-information same-line third-column">
                                    <label className='lbl-wbox'>{t("placeidfill")}</label>
                                    <label className='lbl-wbox-value'>{objectDto.idplace}</label>  
                                </div>
                            </div>
                            
                            <div className="form-group-confirm-information same-line">
                                <label className='lbl-wbox'>{t("addressfill")}</label>
                                <label className='lbl-wbox-value'>
                                    {
                                        objectDto.address + ", " +
                                        ( !isNullOrEmpty(ward) 
                                            ? ward.map((item) => {
                                                if (item.code === objectDto.wardCode) return item.name;
                                                return null;
                                            }).filter((name) => name !== null).join(", ") 
                                            : "" 
                                        // ) + ", " +
                                        // ( !isNullOrEmpty(district) 
                                        //     ? district.map((item) => {
                                        //         if (item.code === objectDto.districtCode) return item.name;
                                        //         return null;
                                        //     }).filter((name) => name !== null).join(", ") 
                                        //     : "" 
                                        ) + ", " +
                                        ( !isNullOrEmpty(province) 
                                            ? province.map((item) => {
                                                if (item.code === objectDto.provinceCode) return item.name;
                                                return null;
                                            }).filter((name) => name !== null).join(", ") 
                                            : "" 
                                        ) + "."
                                    } 
                                </label>
                            </div>
                            
                            <div className="form-group-confirm-information same-line">
                                <label className='lbl-wbox'>{t("addresscontactfill")}</label>
                                <label className='lbl-wbox-value'>
                                {
                                    objectDto.contactAddress + ", " +
                                    ( !isNullOrEmpty(contactWard) 
                                        ? contactWard.map((item) => {
                                            if (item.code === objectDto.contactWardCode) return item.name;
                                            return null;
                                        }).filter((name) => name !== null).join(", ") 
                                        : "" 
                                    // ) + ", " +
                                    // ( !isNullOrEmpty(contactDistrict) 
                                    //     ? contactDistrict.map((item) => {
                                    //         if (item.code === objectDto.contactDistrictCode) return item.name;
                                    //         return null;
                                    //     }).filter((name) => name !== null).join(", ") 
                                    //     : "" 
                                    ) + ", " +
                                    ( !isNullOrEmpty(province) 
                                        ? province.map((item) => {
                                            if (item.code === objectDto.contactProvinceCode) return item.name;
                                            return null;
                                        }).filter((name) => name !== null).join(", ") 
                                        : "" 
                                    ) + "."
                                } 
                                </label>
                            </div>
                        </div>

                        <div className="title-confirm-infor-wrap">
                            <h2 className="title-font-confirm-infor">{t("assuranceproductinformation")}</h2>
                        </div>
                        <div className="border-form-list">
                            <div className="border-form-short-title">
                                <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                    {t("assuranceproduct")}
                                </span>
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form">{objectDto.description + " - " +objectDto.productName}</span>
                            </div>
                            <div className="border-form-short-title">
                                <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                    {t("expiredassurance")}
                                </span>
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form"> 01 năm</span>
                            </div>
                            <div className="border-form-short-title">
                                <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                    {t("expiredfee")}
                                </span>
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form"> 01 năm</span>
                            </div>
                        </div>

                        <div className="border-form-list">
                            <div className="border-form-short-title">
                                    <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                        {t("moneypolicy")}
                                    </span>
                                    <span className="col-md-12 col-sm-12 col-xs-12 value-form">{objectDto.strSumAssured} </span>
                            </div>
                            <div className="border-form-short-title">
                                <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                    {t("feepolicy")}
                                </span>
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                                    {
                                        !isNullOrEmpty(objectDto.discount) && objectDto.discount > 0 ?
                                        ( <>
                                            <span className="old-premium">
                                                {removeDotFromStringMoney(objectDto.premiumOrigin)}{" "}
                                                {t("vnd")}
                                                {t("peryear")}
                                            </span>
                                            <span className="split-premium">{" "}</span>
                                            <span className="new-premium">
                                                {removeDotFromStringMoney(objectDto.premium)}{" "}
                                                {t("vnd")}
                                                {t("peryear")}
                                            </span>
                                            </>
                                        ) :
                                        <span className="col-md-12 col-sm-12 col-xs-12 value-form">
                                            {removeDotFromStringMoney(objectDto.premium)}
                                            {" "} 
                                            {t("vnd")}
                                            {t("peryear")}
                                        </span>
                                    }
                                </span>
                            </div>
                            
                            <div className="border-form-short-title">
                                <span className="col-md-12 col-sm-12 col-xs-12 title-form">
                                    {t("frequencyfee")}
                                </span>
                                <span className="col-md-12 col-sm-12 col-xs-12 value-form">Năm</span>
                            </div>
                            
                        </div>

                        <div className="title-confirm-infor-wrap">
                            <h2 className="title-font-confirm-infor">{t("pleasereaddocument")}</h2>
                        </div>
                        <CardExpandConfirmWidget objectDto={objectDto} />

                        <div className="title-confirm-infor-wrap">
                            <h2 className="title-font-confirm-infor">
                                {t("ruleandpolicyproduct1")}
                                <label style={{textDecorationLine:"underline", fontWeight: "bold"}}>
                                    {t("ruleandpolicyproduct2")}
                                </label>
                                {t("ruleandpolicyproduct3")}
                            </h2>
                        </div>
                        
                            <RuleConfirmWidget setChecked={setChecked} checked={checked} setObjectDto={setObjectDto}/>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default ConfirmInformationSection;